import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Plus, Edit2, Trash2, CreditCard } from 'lucide-react';
import { formatDateWord } from '@/lib/dateFormat';

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-SG', { style: 'currency', currency: 'SGD' }).format(amount || 0);
};

const formatDate = (dateString) => {
  return formatDateWord(dateString);
};

const OrderPaymentsTab = ({ orderData, onOpenPaymentDialog, onDeletePayment }) => {
  return (
    <Card className="bg-white border border-slate-200/50 shadow-sm">
      <CardHeader className="border-b border-slate-100 flex flex-row items-center justify-between">
        <div>
          <CardTitle className="text-lg">Payment History</CardTitle>
          <CardDescription>Total paid: {formatCurrency(orderData.deposit_paid)}</CardDescription>
        </div>
        <Button onClick={() => onOpenPaymentDialog()}>
          <Plus className="w-4 h-4 mr-2" />
          Add Payment
        </Button>
      </CardHeader>
      <CardContent className="p-0">
        {!orderData.payments?.length ? (
          <div className="p-8 text-center text-slate-500">
            <CreditCard className="w-12 h-12 mx-auto mb-3 opacity-50" />
            <p>No payments recorded</p>
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="text-xs uppercase">Date</TableHead>
                <TableHead className="text-xs uppercase">Amount</TableHead>
                <TableHead className="text-xs uppercase">Method</TableHead>
                <TableHead className="text-xs uppercase">Notes</TableHead>
                <TableHead className="text-xs uppercase w-24">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {orderData.payments.map((payment) => (
                <TableRow key={payment.payment_id}>
                  <TableCell>{formatDate(payment.payment_date)}</TableCell>
                  <TableCell className="font-semibold text-emerald-600">{formatCurrency(payment.amount)}</TableCell>
                  <TableCell>{payment.payment_method}</TableCell>
                  <TableCell className="text-slate-500 max-w-[200px] truncate">{payment.notes || '—'}</TableCell>
                  <TableCell>
                    <div className="flex items-center gap-1">
                      <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => onOpenPaymentDialog(payment)}>
                        <Edit2 className="w-4 h-4" />
                      </Button>
                      <Button variant="ghost" size="icon" className="h-8 w-8 text-red-500" onClick={() => onDeletePayment(payment.payment_id)}>
                        <Trash2 className="w-4 h-4" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};

export default OrderPaymentsTab;